import RedoSquareIcon from "@redotech/redo-icons/redo-square.svg";
import ShopifyIcon from "@redotech/redo-icons/shopify_glyph_black.svg";
import {
  BookOpen,
  Calendar,
  Instagram,
  Linkedin,
  Podcast,
  Search,
  Shapes,
  Users,
  Youtube,
} from "lucide-react";
import type { IntakeQuestion } from "../../registry/types";

/**
 * Intake questions shown in the blocking modal before the widget appears.
 * Keep to ~3 — every question is friction. All single-select for v1.
 *
 * (Monthly chargeback volume isn't asked here — we already pull it from
 * the Shopify integration.)
 *
 * Copy is placeholder; wording will be polished by product/UX before launch.
 */
export const DISPUTES_INTAKE_QUESTIONS: IntakeQuestion[] = [
  {
    id: "attribution_source",
    type: "single-select",
    prompt: "Where did you hear about us?",
    required: true,
    layout: "grid",
    options: [
      { value: "search", label: "Search engine", Icon: Search },
      {
        value: "shopify_app_store",
        label: "Shopify app store",
        Icon: ShopifyIcon,
      },
      { value: "linkedin", label: "LinkedIn", Icon: Linkedin },
      { value: "youtube", label: "YouTube", Icon: Youtube },
      { value: "social", label: "Instagram, X, or TikTok", Icon: Instagram },
      { value: "podcast", label: "Podcast", Icon: Podcast },
      { value: "article", label: "Article or blog post", Icon: BookOpen },
      { value: "referral", label: "Friend or colleague", Icon: Users },
      { value: "event", label: "Event or conference", Icon: Calendar },
      {
        value: "existing_redo",
        label: "I'm already using Redo",
        Icon: RedoSquareIcon,
      },
      { value: "other", label: "Somewhere else", Icon: Shapes },
    ],
  },
  {
    id: "current_process",
    type: "single-select",
    prompt: "How are you handling chargebacks today?",
    required: true,
    options: [
      { value: "nothing", label: "Not handling them" },
      { value: "manual", label: "Manually responding to each one" },
      { value: "agency", label: "Using an outside agency" },
      { value: "competitor", label: "Using another chargeback tool" },
    ],
  },
  {
    id: "primary_goal",
    type: "single-select",
    prompt: "What outcome matters most to you?",
    required: true,
    options: [
      { value: "recover_revenue", label: "Recover lost revenue" },
      { value: "save_time", label: "Save time on responses" },
      { value: "automate_fully", label: "Automate the whole process" },
    ],
  },
];
